<ng-template #cpuInput>
  <div class="slider">
    <div class="label">{{ formData.label }} {{ display }} Std.</div>
    <mat-slider [max]="max"
                [min]="min"
                [showTickMarks]="2"
                [step]="5"
                color="primary">
      <input (valueChange)="onSliderMove($event)"
             [formControl]="$any(formGroup.controls[formName])"
             matSliderThumb>
    </mat-slider>
  </div>
</ng-template>

<app-base [childContext]="ctx" [componentsTemplate]="cpuInput"></app-base>
